import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';


const technologies = [
  { name: "Asp .Net", logo: "/assets/img/asp.png" },
  { name: "React", logo: "/assets/img/react1.png" },
  { name: "Angular", logo: "/assets/img/angular.png" },
  { name: "Node.js", logo: "/assets/img/node.png" },
  //{ name: "WooCommerce", logo: "/assets/img/sql.png" },
 // { name: "Webflow", logo: "/assets/img/webflow.png" },
  { name: "Razpor-pay", logo: "/assets/img/Razpor-pay.png" },
  { name: "PHP", logo: "/assets/img/php.png" },
  { name: "React Native", logo: "/assets/img/react-native.png" },
  { name: "aws", logo: "/assets/img/aws.png" },
  { name: "Python", logo: "/assets/img/python.png" },
  { name: "azure", logo: "/assets/img/azure.png" },
  //{ name: "HighLevel", logo: "/assets/img/highlevel.png" },
  //{ name: "HubSpot", logo: "/assets/img/hubspot.png" },
  { name: "Laravel", logo: "/assets/img/laravel.png" },
];

const Technologies = () => {
  return (
    <section className="w-full bg-white py-16 px-4">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-4xl font-semibold mb-10">
          Our <span className="text-blue-500 italic">Tech Capabilities</span>
        </h2>

        {/* Carousel for Mobile, Grid for md+ */}
        <div className="md:grid md:grid-cols-5 gap-8 hidden md:block">
          {technologies.map((tech, index) => (
            <div
                key={index}
                className="flex flex-col items-center gap-2 p-4 rounded-lg transform transition duration-300 hover:scale-105 hover:shadow-md hover:shadow-blue-200"
                >
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="h-14 md:h-16 object-contain transition duration-300"
                />
                <p className="text-sm font-medium text-gray-800">{tech.name}</p>
              </div>
          ))}
        </div>

        {/* Mobile Carousel */}
        
          {/* Mobile Autoplay Carousel */}
              <div className="md:hidden px-2">
                <Swiper
                  modules={[Autoplay]}
                  autoplay={{ delay: 2000, disableOnInteraction: false }}
                  spaceBetween={16}
                  slidesPerView={2}
                  loop={true}
                  breakpoints={{
                    480: {
                      slidesPerView: 3,
                    },
                  }}
                >
                  {technologies.map((tech, index) => (
                    <SwiperSlide key={index}>
                      <div className="w-full flex flex-col items-center gap-2 p-4 rounded-xl bg-white shadow-sm transform transition duration-300 hover:scale-105 hover:shadow-md hover:shadow-blue-200">
                        <img
                          src={tech.logo}
                          alt={tech.name}
                          className="h-14 object-contain transition duration-300"
                        />
                        <p className="text-xs text-center font-medium text-gray-800">
                          {tech.name}
                        </p>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>


      </div>
    </section>
  );
};

export default Technologies;
